<template lang="html">
  <v-card
    color="grey darken-4"
    class="mx-auto mb-4"
    v-ripple
    style="cursor: pointer; position: relative; overflow: hidden;"
    @click="onResourceDetail(resource)"
  >
    <div class="d-flex overflow-hidden">
      <img
        v-if="resource.first_image"
        alt="Image of room"
        style="object-fit: cover; width: 100%; height: 100%"
        :src="getImageUrl((resource.first_image.resource || resource.id), (resource.first_image.image || resource.first_image))"
        class="rounded"
      >
      <div style="margin-top: 75%;"></div>
    </div>
    <div
      class="white--text rounded pa-4 pb-16"
      style="
        position: absolute;
        top: 0; left: 0; right: 0;
        text-shadow: 1px 1px 4px black;
        background: rgb(0,0,0);
        background: linear-gradient(rgb(0, 0, 0) 0%, rgb(0 0 0 / 45%) 44%, rgba(255, 255, 255, 0) 100%);
      "
    >
      <div class="headline mt-2 mb-4">
        <div class="d-flex">
          <div class="flex-grow-1">
            {{resource.title}}
          </div>
          <div class="">
            <v-icon color="white">mdi-chevron-right</v-icon>
          </div>
        </div>
      </div>
      <div class="body-1 mb-4">
        {{resource.short_description}}
      </div>
      <span v-if="resource.guests" class="secondary rounded-pill py-1 px-2" style="text-shadow: none;">
        <v-icon color="white" size="19" class="mt-n1">mdi-account-multiple</v-icon> <span class="font-weight-bold">{{resource.guests}}</span>
      </span>
    </div>
  </v-card>
</template>

<script>
import {apiUrl} from '@dynapp/wc-api-generic';

export default {
  name: 'BookingOption',
  props: {
    resource: {
      default: () => ({})
    },
    calendar: {}
  },
  methods: {
    getImageUrl(resourceId, imageName) {
      return apiUrl({dataObject: 'custombooking'}, `calendars/${this.calendar.id}/resources/public/${resourceId}/attachments/${imageName}?cache=86400`);
    },
    onResourceDetail(item) {
      this.$emit('click', item);
    }
  }
}
</script>

<style lang="css" scoped>
</style>
